export async function getTheme() {
  try {
    const response = await fetch('/api/theme');
    const data = await response.json();
    console.info('Fetched theme from server:', data.theme);
    return data.theme;
  } catch {
    console.warn('Could not fetch theme from server, using default');
    return '';
  }
}
